import { render, staticRenderFns } from "./report-ecom-orders.vue?vue&type=template&id=56c07050"
import script from "./report-ecom-orders.vue?vue&type=script&lang=js"
export * from "./report-ecom-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports